export default {
  "content": "<circle cx=\"16\" cy=\"16\" r=\"16\" fill=\"#F4F8AC\"/><path d=\"M11.367 15.886v9.132m11.771-17.96v6.729c0 .851-.786 1.542-1.758 1.542H19.97c-.971 0-1.758-.69-1.758-1.542V7.059m2.463.001v17.957M14.283 12.21c0-2.305-1.027-5.151-2.908-5.151s-2.906 2.846-2.906 5.15c0 2.306 1.288 3.27 2.906 3.27s2.908-.964 2.908-3.27z\" stroke=\"#1D1D1B\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>",
  "attrs": {
    "width": "32",
    "height": "32",
    "viewBox": "0 0 32 32",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};